import { Component, inject, TemplateRef } from '@angular/core';
import { NgClass } from '@angular/common';

import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'toast-notification',
    imports: [NgbToastModule, NgClass],
    templateUrl: './toast-notification.component.html',
    styleUrls: ['./toast-notification.component.scss'],
    host: { 'class': 'toast-container' }
})
export class ToastNotificationComponent {
  public readonly notificationService = inject(NotificationService);

  isTemplate(toast: any) { return toast.textOrTpl instanceof TemplateRef; }

}
